export default __webpack_public_path__ + "static/media/2.14514174.jpg";